<template>
  <transition name="fade">
    <div class="container">
      <div class="center">
        <lottie
          :options="defaultOptions"
          :height="96"
          :width="96"
          v-on:animCreated="handleAnimation"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import loader from "@/config/constantes/loader";
import Lottie from "vue-lottie";
export default {
  name: "LottieLoader",
  components: {
    lottie: Lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: loader },
      animationSpeed: 1,
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
div.container {
  position: fixed;
  display: table;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background: #043263; */
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

div.center {
  display: table-cell;
  vertical-align: middle;
}
</style>
